

document.addEventListener('DOMContentLoaded', () => {
    const tabComponents = document.querySelectorAll('.tabs-component');

    tabComponents.forEach(component => {
      const buttons = component.querySelectorAll('.tabs-component__tab');
      const contents = component.querySelectorAll('.tabs-component__content');

      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            console.log("Click", e)
          const tabId = button.dataset.tab;

          buttons.forEach(btn => btn.classList.remove('is-active'));
          contents.forEach(c => c.classList.remove('is-active'));

          button.classList.add('is-active');
          const targetContent = component.querySelector(`.tabs-component__content[data-tab-id="${tabId}"]`);
          if (targetContent) {
            targetContent.classList.add('is-active');
          }
        });
      });
    });
  });